import { React, formfields, models, kea, history, resources, selectores, componentToRx } from "app/main/std";
var Markdown = require('react-markdown');

interface Props {
    puedeModificar: boolean;
    value: string;
    onChange: (value: string) => void;
    onGuardar: () => void;
}

class KeaMarkdownNoRX extends React.PureComponent<Props, { editando: boolean }> {
    constructor(props: Props) {
        super(props);
        this.state = { editando: false };
    }

    private onModificar = async () => {
        var nuevo = !this.state.editando;
        this.setState({ editando: nuevo });
    }

    private onGuardar = async () => {
        await this.setState({ editando: false });
        this.props.onGuardar();
    }

    render() {

        return (
            <div>
                {
                    this.props.puedeModificar && !this.state.editando &&
                    <div className="row" style={{ textAlign: "right" }}>
                        <kea.Link iconClass="fa fa-pencil-square-o fa-3x" onClick={this.onModificar} tooltip="Modificar" />
                    </div>
                }
                <div className="row">
                    <div style={{ textAlign: "justify" }}>
                        {
                            !this.state.editando &&
                            <Completo {...this.props} onGuardar={this.onGuardar} />
                        }
                        {
                            this.state.editando &&
                            <Modificando {...this.props} onGuardar={this.onGuardar} />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class Completo extends React.PureComponent<Props> {

    render() {
        const x = this.props.value;
        return (
            <div>
                <div className="col-md-12">
                    <Markdown source={x} />
                </div>
            </div>
        )
    }
}

class Modificando extends React.PureComponent<Props> {

    render() {
        const { value, onGuardar } = this.props;

        return (
            <div>
                <div className="col-md-6">
                    <Markdown source={value} />
                </div>
                <div className="col-md-6">
                    <div className="row">
                        <kea.Text value={value} onChange={this.props.onChange} multiline={true} />
                    </div>
                    <div className="row">
                        <kea.GuardarButton onClick={onGuardar} />
                    </div>
                </div>
            </div>
        )
    }
}

export const KeaMarkdown = componentToRx(KeaMarkdownNoRX);


// WEBPACK FOOTER //
// ./app/features/componentes/keamarkdown.tsx